import { useAppInfoRetry } from '@/app/useAppInfoRetry';
import SessionUnavailablePanel from './SessionUnavailablePanel';

/**
 * Shown by ProtectedRoute in place of a signed-in page whose /api/info call
 * failed (#2399): the page's classification banner and role checks need it.
 * Retries on its own while it is shown; Retry tries at once.
 */
export default function AppInfoUnavailablePanel() {
  const retryNow = useAppInfoRetry();
  return (
    <SessionUnavailablePanel
      message="We can't reach brewlytics right now."
      actionLabel="Retry"
      onAction={retryNow}
    />
  );
}
